import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import AsyncSelect from 'react-select/async'
import { GetReferenceCountries, GetReferenceCurrencies, GetReferenceStates, GetReferenceFilteredStates, 
      LoadCitiesReference, } from '../../service/ReferenceData';

const StyledAsyncSelect = styled(AsyncSelect, {
  shouldForwardProp: (prop) => prop !== 'optionsType' && prop !== 'selected',
})(({ theme, optionsType, selected }) => {
  const isCountry = optionsType === 'country' || optionsType === 'state' || optionsType === 'city';

  const baseStyles = {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif;',
  };

  if (isCountry) {
    return {
      ...baseStyles,
      width: theme.spacing(24),
      height: selected ? '42px' : '20px',
      [theme.breakpoints.down('sm')]: {
        width: theme.spacing(30),
        marginTop: selected ? 0 : '22px',
        marginBottom: selected ? '8px' : '26px',
      },
    };
  }

  // isCurrency or miType
  return {
    ...baseStyles,
    width: theme.spacing(50),
    height: '42px',
    [theme.breakpoints.down('sm')]: {
      width: theme.spacing(30),
      marginTop: selected ? 0 : '22px',
      marginBottom: selected ? '8px' : '26px',
    },
  };
});

function AsyncReactSelect(props) {
  const [name, setName] = useState(props.name);
  const [label, setLabel] = useState(props.label);
  const [value, setValue] = useState(props.value);
  const [inUnitedStates, setInUnitedStates] = useState(props.inUnitedStates);
  const [placeholder, setPlaceholder] = useState(props.placeholder);
  const [errorText, setErrorText] = useState(props.errorText);
  const [required, setRequired] = useState(props.required);
  const [summary, setSummary] = useState(props.summary);
  const [uniqId, setUniqId] = useState(props.uniqId);
  const [onUSA, setOnUSA] = useState(props.onUSA);
  const [filter, setFilter] = useState(props.filter);
  const [filterCountry, setFilterCountry] = useState(props.filterCountry);
  const [filterCity, setFilterCity] = useState(props.filterCity);

  const [error, setError] = useState(false);
  const [selected, setSelected] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [countries, setCountries] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [otherCities, setOtherCities] = useState('OTHER');

  const [miTypes, setMiTypes] = useState([ {value: 'cash', otherTypeDescription: 'Cash/Currency', label: 'Cash/Currency'},
    {value: 'coin', otherTypeDescription: 'Coin', label: 'Coin'},
    {value: 'stock', otherTypeDescription: 'Securities/Stocks', label: 'Securities/Stocks'},
    {value: 'tvlch', otherTypeDescription: 'Travelers Check', label: 'Travelers Check'},
    {value: 'ncheck', otherTypeDescription: '*NI: Check', label: 'Negotiable Instruments: Check'}, 
    {value: 'npnote', otherTypeDescription: '*NI: Promissory Note', label: 'Negotiable Instruments: Promissory Note'},
    {value: 'nmnord', otherTypeDescription: '*NI: Money Order', label: 'Negotiable Instruments: Money Order'},
    {value: 'icheck', otherTypeDescription: '*II: Check', label: 'Incomplete Instruments: Check'}, 
    {value: 'ipnote', otherTypeDescription: '*II: Promissory Note', label: 'Incomplete Instruments: Promissory Note'},
    {value: 'imnord', otherTypeDescription: '*II: Money Order', label: 'Incomplete Instruments: Money Order'},]);

  useEffect(() => {
    if (props.inUnitedStates === true) {    
      setStates(GetReferenceFilteredStates('USA'))
    } else {
      setStates(GetReferenceFilteredStates())
    }   
  }, [props.inUnitedStates])

  useEffect(() => {
    setValue(props.value)
  }, [props.value])
  useEffect(() => {
    setLabel(props.label)
  }, [props.label])
  useEffect(() => {
    setSummary(props.summary)
  }, [props.summary])
  useEffect(() => {
    setRequired(props.required)
    setError(props.required? undefined : false)
    setErrorText(props.required? undefined : '')
  }, [props.required])
  // useEffect(() => {
  //   setFilterCountry(props.filterCountry)
    // setValue(props.filterCountry)
  // }, [props.filterCountry])
  useEffect(() => {
    if (props.filter !== undefined && props.filter !== null && props.filter !== "") {
        const newStates = GetReferenceFilteredStates(props.filter) 
      setStates(newStates)
      setFilter(props.filter)
      setCities('')
      setValue('')
    }
  }, [props.filter])
  useEffect(() => {
    if (props.filterCity !== undefined && props.filterCity !== null && props.filterCity !== "") {
      setValue('')
      setCities('')
      setIsLoading(true)
      getCities(props.filterCity)
    }
  }, [props.filterCity])

  const getCities = (stateCode) => {
      const newCities = LoadCitiesReference(stateCode)
      newCities.then(result => {
        if(result !== undefined)  {
          const parsedresult = result.map(city => ({
                    value: city.cityCode,            
                    label: city.cityName,
                    stateDescription: city.cityName,
                    stateCode: city.stateCode,
                    stateName: city.stateName,
                    countryCode: city.countryCode
                  }))
          parsedresult.push({
            value: 'OTHER',
            label: 'OTHER', 
            stateDescription: 'XX',
            stateName: 'OTHER',
            stateCode: 'XX',
            countryCode: undefined
          })  
          setCities(parsedresult)
      } else {
        console.log('No cities returned from the service call for ' + stateCode)
        const otherOption = [{
          value: 'OTHER',
            label: 'OTHER', 
            stateDescription: 'XX',
            stateName: 'OTHER',
            stateCode: 'XX',
            countryCode: undefined
        }]
        setCities(otherOption)
      }
      setFilterCity(stateCode)
      setIsLoading(false)
     })
  }

  const validateInput = (propertyName, value) => (event) => {    
    // alert(propertyName + ' validate ' + JSON.stringify(value) + ' value event ')    
    // console.log(JSON.stringify(value) + ' event ' + event.currentTarget + ' ' + state.value)
    if (value === null || value === "") {
      setError(true)
      props.handleError(propertyName, true)
    } else {      
      setError(false)
      props.handleError(propertyName, false)
    }
  }

  const resetInputValidation = (propertyName, value) => {    
    // alert(propertyName + ' validate ' + JSON.stringify(value) + ' value event ')    
    // console.log(JSON.stringify(value) + ' reset ' + state.value)
    if (value === null || value === "") {
      setError(true)
      props.handleError(propertyName, true)
    } else {  
      setError(false)
      props.handleError(propertyName, false)
    }
  }

  const handleClick = (propertyName) => (event) => {
    setSelected(true)
  }

  const handleSelectChange = (name, selectedOption) => (event) => {
    // console.log(name + " async " + JSON.stringify(event) + " " + JSON.stringify(state.value))
    // alert('handlechange ' + JSON.stringify(event))
    // setState({ value: event, selected: true });
    if (event === null || event === "") {
      event = '';
    } else {
      setValue(event)
      setSelected(true)
    }

    props.handleChange(name, event )

    if (required) {      
      if (event !== '') {
        setError(false)
        props.handleError(name, false)
      }
    }
    //Ipad blur event does not pass the value, which makes the component to be in error even when a value is selected
    //The following statement will reset the error state of the component
    setTimeout(() => { resetInputValidation(name, event); }, 150)
  }
 
  const filterCountries = (inputValue, onUSA) => {
    let newCountries
   if (countries.length === 0) {
      newCountries = GetReferenceCountries()
      setCountries(newCountries)
    } else {
      newCountries = countries
    }

    let findUSA = newCountries.find(o=>o.value === 'USA');
    let indexUSA = newCountries.indexOf(findUSA);
    let findUMI = newCountries.find(o=>o.value === 'UMI');
    let indexUMI = newCountries.indexOf(findUMI);

    if(onUSA === true) {
      newCountries.splice(indexUSA,1);
      newCountries.splice(indexUMI,1);
    } else {
      setOnUSA(false)
    }
    // console.log('countgries length ' + countries.length)
    
    return newCountries.filter(i => 
        i.value.toLowerCase().includes(inputValue.toLowerCase()) ||
        i.countryDescription.toLowerCase().includes(inputValue.toLowerCase())
    );
  };
  
  const countryOptions = (inputValue, onUSA) =>      
    new Promise(resolve => {
      setTimeout(() => {
        resolve(filterCountries(inputValue,onUSA));
    }, 1000);
  });

  const filterCurrencies = (inputValue) => {
    let newCurrencies
    if (currencies.length === 0) {
      newCurrencies = GetReferenceCurrencies()
      setCurrencies(newCurrencies)
    } else {
      newCurrencies = currencies
    }

    return newCurrencies.filter(i =>        
        i.countryDescription.toLowerCase().includes(inputValue.toLowerCase()) ||
        i.currencyName.toLowerCase().includes(inputValue.toLowerCase()) ||
        i.value.toLowerCase().includes(inputValue.toLowerCase()) ||
        (i.currencyCode !== undefined && i.currencyCode.toLowerCase().includes(inputValue.toLowerCase()))        
    );
  };
  
  const currencyOptions = inputValue =>      
    new Promise(resolve => {
      setTimeout(() => {
        resolve(filterCurrencies(inputValue));
      }, 1000);
  });
  
  const filterStates = (inputValue) => {
    let newStates;
    // console.log("in filterstates " + inputValue)
    if (states.length === 0) {
      if (props.inUnitedStates === true) {
        newStates = GetReferenceFilteredStates('USA')  
        // setState({ states: GetReferenceFilteredStates('USA') })
      } else {
        newStates = GetReferenceStates()  
        // setState({ states: GetReferenceStates() })
      } 
      setStates(newStates)
      // states = newStates
     } else {
      newStates = states
     }
      return newStates.filter(i =>        
      ((i.stateDescription !== undefined && i.stateDescription.toLowerCase().includes(inputValue.toLowerCase())) ||     
      (i.value.toLowerCase().includes(inputValue.toLowerCase()))) );
  };
  
  const stateOptions = inputValue =>      
    new Promise(resolve => {
      setTimeout(() => {
        resolve(filterStates(inputValue));
      }, 1000);
  });

  const filterCities = (inputValue) => {
    // console.log('cities length ' + cities.length)
    if(cities !==undefined && cities.length >0) {
    return cities.filter(i =>        
      (i.label.toLowerCase().includes(inputValue.toLowerCase())));
    }
  };
  
  const cityOptions = inputValue =>      
    new Promise(resolve => {
      setTimeout(() => {
        resolve(filterCities(inputValue));
      }, 2000);
  });

  const filterOtherTypes = (inputValue) => {
    return miTypes.filter(i =>        
      (i.otherTypeDescription.toLowerCase().includes(inputValue.toLowerCase())) ||     
      (i.value.toLowerCase().includes(inputValue.toLowerCase())));           
  };
  
  const otherTypeOptions = inputValue =>      
    new Promise(resolve => {
      setTimeout(() => {
        resolve(filterOtherTypes(inputValue));
      }, 1000);
  });

  const noOptionsMessage = (inputValue) => {
    return (
     <Typography>some text</Typography>
    );
  }
  const redstar = <span style={{ color: '#9C2F36' }}>*</span>;
  const reqlabel = <>{label}{redstar}</>;
  
  return (
    <Grid>
        <Grid sx={{
          backgroundColor: '#ffffff',
          ml: 1,
          mr: 1,
          mt: { xs: 1.25, sm: 0 },
        }}>
          {selected && <Typography component="label" sx={{ fontSize: '0.75rem', color: error ? '#9C2F36' : '#525252', ml: 1 }} data-shrink='true'>{label} </Typography>}
          {selected && required && <Typography component="label" sx={{ ml: '3px', color: '#9C2F36' }} data-shrink='true'>*</Typography>}
        </Grid>
        <StyledAsyncSelect
          multiline
          optionsType={props.optionsType}
          selected={selected}
          cacheOptions
          loadOptions={props.optionsType === 'country'? countryOptions : props.optionsType === 'currency'? currencyOptions  : 
                                        props.optionsType === 'miType'? otherTypeOptions : props.optionsType === 'state'? stateOptions : cityOptions}
          defaultOptions={props.optionsType === 'state'? states : props.optionsType === 'city'? cities : true}
          onFocus={handleClick(name)}         
          onChange={handleSelectChange(name, value)}
          // onInputChange={handleSelectChange(name, value)}
          onBlur={validateInput(name, value)}
          isDisabled={summary}
          isLoading={isLoading || props.isLoading}                    
          isClearable={summary? false : true}
          isRtl={false}
          isSearchable={true}
          hideSelectedOptions={true}
          inputId ={uniqId}
          name={name}
          placeholder={error? errorText : required? reqlabel : label}
          aria-label = {label}
          value={value}
          // inputValue={value}
          // variant="standard"
          slotProps={{ textField: { variant: "standard" } }}
          components={{
            IndicatorSeparator: () => null,          
            ClearIndicator: () => null,
            NoOptionsMessage: () => <Typography sx={{ textAlign: 'center', boxSizing: 'border-box', padding: '8px 12px' }}>{isLoading? 'Please wait. Loading....' : 'No Options'}</Typography>
            // DropdownIndicator: () => null
          }}
          styles={{ control: base => ({ ...base, borderWidth: '0 0 1px 0', borderRadius: '0', backgroundColor: '#ffffff', 
                                                  borderColor: error? '#9C2F36' : '#0000006b' }),
                    placeholder: base => ({ ...base, color: error? '#9C2F36' : '#525252', }),
                    singleValue: base => ({ ...base, color: summary? '#000000' : '#333333', paddingLeft: '0px' }),
                    valueContainer: base => ({ ...base, backgroundColor: '##ffffff', paddingLeft: '0px', }), 
                  }}
        />
    </Grid> 
  );
}

export default AsyncReactSelect;